import DashboardComplexFiltersContainer from './containers/DashboardComplexFiltersContainer';

export default DashboardComplexFiltersContainer;
